import { HStack, VStack } from '@chakra-ui/react';
import CoreButton, { CoreButtonProps } from './CoreButton';
import { CoreBlock } from '../../types';
import { useBlocksContext } from '../../lib/blocks.context';

interface CoreButtonsProps {
  block: CoreBlock & {
    innerBlocks: CoreButtonProps['block'][];
  };
  renderBlocks: (block: CoreBlock, i: number) => JSX.Element;
}

const CoreButtons: React.FC<CoreButtonsProps> = ({ block, renderBlocks }) => {
  const { layoutType } = useBlocksContext();

  const justifyContentMap: Record<string, string> = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end',
    'space-between': 'space-between',
  };
  const sizeMap: Record<string, 'md' | 'lg'> = {
    medium: 'md',
    large: 'lg',
  };

  const justify =
    justifyContentMap[block.attrs?.layout?.justifyContent || 'flex-start'];
  const size = sizeMap[block.attrs?.fontSize || 'md'];
  const Stack =
    block.attrs?.layout?.orientation === 'vertical' ? VStack : HStack;

  return (
    <Stack
      spacing={0}
      gap={4}
      justify={justify}
      flexWrap="wrap"
      _last={{
        marginBottom: 0,
      }}
      marginBottom={layoutType === 'basic' ? 6 : 0}
    >
      {block.innerBlocks?.map((innerBlock, index: number) => (
        <CoreButton
          block={innerBlock}
          key={`core-button-${index}`}
          size={size}
        />
      ))}
    </Stack>
  );
};

export default CoreButtons;
